<div *ngIf="source" class="content_iframe">
    <iframe allowfullscreen [src]="source" width="{{ iframe.content['width'] }}" height="{{ iframe.content['height'] }}"></iframe>
</div>
